import React from "react";
import StorefrontPage from "../../components/core/StorefrontPage";
import {StorefrontListingContainer} from "./containers/storefront-listing.container";

/**
 * StorefrontShellPage — public storefront product listing shell.
 * Wires StorefrontListingContainer into the /shop OpenRoute.
 */
const StorefrontShellPage: React.FC = () => {
    return (
        <StorefrontPage>
            <StorefrontListingContainer />
        </StorefrontPage>
    );
};

export default StorefrontShellPage;
